export default {
    namespaced: true,
    state() {
        return {
            result: 0,
        }
    },
    getters: {
        getResult(state) {
            return state.result;
        },
    },
    mutations: {
        
    },
    actions: {
        
    },
}
